import { WavePattern } from './WavePattern';
import { services } from './constants';
import { useLang } from '../../contexts/LanguageContext';

// "What we build" service catalogue. Icons come from constants.services;
// titles + descriptions zip in by index from i18n.
export const FeaturesSection = () => {
  const { t } = useLang('features');

  return (
    <section id="features" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#111111] relative overflow-hidden">
      <WavePattern className="inset-0 w-full h-full" opacity={0.06} />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-1 w-8 bg-[#00CED1] rounded-full" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00CED1]">{t.eyebrow}</span>
            <span className="h-1 w-8 bg-[#00CED1] rounded-full" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4 text-white">
            {t.title}
          </h2>
          <p className="text-lg text-white/40 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => {
            const Icon = service.icon;
            const item = t.items?.[i] || { title: service.title, description: service.description };
            return (
              <div
                key={item.title}
                className="group p-8 bg-white/[0.03] border border-white/[0.06] rounded-xl hover:border-[#00CED1]/30 hover:bg-white/[0.05] transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-[#00CED1]/10 flex items-center justify-center mb-5 group-hover:bg-[#00CED1]/20 transition-colors">
                  <Icon className="h-6 w-6 text-[#00CED1]" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-white">{item.title}</h3>
                <p className="text-white/40 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
